import { render, staticRenderFns } from "./GroundTruthTrainingQualityTable.vue?vue&type=template&id=498b6429&scoped=true&"
import script from "./GroundTruthTrainingQualityTable.vue?vue&type=script&lang=js&"
export * from "./GroundTruthTrainingQualityTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498b6429",
  null
  
)

export default component.exports